export const environment = {
  production: false,
  emailjsServiceId: 'service_2m7bmpq',
  emailjsTemplateId: 'template_czz20br',
  emailjsPublicKey: 'x9l56T3C-SAqbOCNh'
};